import React, { useCallback, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Input } from '../Input';
import { useOnClickOutside } from '../../../utils/hooks/useOnClickOutside';


var HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{0,6})$/;
var ColorPicker = function (_a) {
    var onChange = _a.onChange, value = _a.value, label = _a.label, disabled = _a.disabled, error = _a.error;
    var _b = useState(false), isColorPickerOpen = _b[0], setIsColorPickerOpen = _b[1];
    var handleChange = useCallback(function (_a) {
        var value = _a.value;
        if (!HEX_COLOR_REGEX.test(value)) {
            return;
        }
        var upperCaseHexColor = value.toUpperCase();
        onChange === null || onChange === void 0 ? void 0 : onChange({ value: upperCaseHexColor });
    }, [onChange]);
    var handleColorCircleClick = useCallback(function () {
        if (disabled) {
            return;
        }
        setIsColorPickerOpen(function (previousValue) { return !previousValue; });
    }, []);
    var colorPickerRef = useRef(null);
    useOnClickOutside(colorPickerRef, function () { return setIsColorPickerOpen(false); });
    var handleColorPickerChange = useCallback(function (color) {
        var upperCaseColor = color.toUpperCase();
        onChange === null || onChange === void 0 ? void 0 : onChange({ value: upperCaseColor });
    }, [onChange]);
    return (React.createElement("div", { ref: colorPickerRef, className: 'ColorPicker' },
        React.createElement(Input, { type: 'text', label: label, value: value, onChange: handleChange, disabled: disabled, error: error, icon: React.createElement("div", { className: "circle " + (disabled ? 'disabled' : ''), style: { backgroundColor: value }, onClick: handleColorCircleClick }) }),
        isColorPickerOpen && (React.createElement(HexColorPicker, { color: value, onChange: handleColorPickerChange }))));
};
export { ColorPicker };
